// -- Feature Tracker
export const MAX_CNT = 500;
export const MAX_ROT_RATE = 90 * Math.PI / 180;
export const USE_IMAGE_FILTER = 1;
export const MAX_SIZE = 160 * 160;
